module.exports = __webpack_public_path__ + "img/background2.5a490691.png";